import * as React from "react";

const contextRef = React.createRef(null);

export default contextRef;
